import { SwitchContext } from './types'

// TODO: Clean this up when inline arcade is 100% enabled. These are keys within summary:error.* that have inline context
export const isKeyWithInlineContext = (reason: string, context?: SwitchContext): boolean => {
  const keysWithInlineContext: Record<string, SwitchContext[]> = {
    cardExpiry: [SwitchContext.CannotSwitch],
    foreignCard: [],
    prepaidCard: [],
    invalidBrand: [SwitchContext.CannotSwitch],
    unacceptableCard: [SwitchContext.CannotSwitch, SwitchContext.Switched],
    unacceptableIssuerRestrictedCard: [SwitchContext.CannotSwitch, SwitchContext.Switched],
    fallbackGenericMessage: [SwitchContext.Switched],
    checkingNotAllowed: [SwitchContext.Switched],
    creditCardNotAllowed: [SwitchContext.CannotSwitch],
    cashAppCardIneligible: [SwitchContext.CannotSwitch, SwitchContext.Switched],
  }

  if (!Object.keys(keysWithInlineContext).includes(reason)) {
    return false
  }

  const validContexts = keysWithInlineContext[reason]

  const isValidNoContext = !context && validContexts.length === 0
  const isValidWithContext = !!context && validContexts.includes(context)

  return isValidNoContext || isValidWithContext
}
